import { usePaging } from 'hooks/usePaging';
import { useCallback } from 'react';
import { useGetServiceTypeCMISQuery } from 'services';
import { FindAllServiceTypeCMISDto, UseQueryOptionsType } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useServiceTypesCMIS(
  params: Omit<FindAllServiceTypeCMISDto, 'pageIndex' | 'pageSize'>,
  options?: UseQueryOptionsType
) {
  const { pageIndex, resetPage, nextPage } = usePaging(params);
  const {
    data: dataResponse,
    isLoading,
    isFetching
  } = useGetServiceTypeCMISQuery(
    {
      pageIndex: pageIndex,
      pageSize,
      ...params
    },
    {
      ...options
    }
  );
  const { rows, count } = dataResponse?.data || {};

  const hasMore = Boolean(rows && count && rows.length < count);
  const handleLoadMore = useCallback(() => {
    if (hasMore && !isFetching) {
      nextPage();
    }
  }, [hasMore, pageIndex]);

  return {
    serviceTypeCMIS: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    resetPage
  };
}
